import axios from 'axios';
import { message } from 'antd';

const API_SERVER = '/api';
export const API_SERVER_UPLOAD = '/api/vendor/upload';

const api = axios.create({
  baseURL: API_SERVER,
  headers: {
    'Content-Type': 'application/json',
    'HTTP_X_REQUESTED_WITH': 'XMLHttpRequest'
  },
  timeout: 1000 * 10 * 2,
  transformRequest: [(data) => {
    // NProgress.start()
    if (!data) {
      return '';
    }
    return JSON.stringify(data);
  }],
  transformResponse: axios.defaults.transformResponse
});

api.interceptors.request.use((config) => {
  const timestamp = new Date().getTime();
  if (config.url.indexOf('?') > 0) {
    config.url += `&_t=${timestamp}`;
  } else {
    config.url += `?_t=${timestamp}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    if (!response.data) {
      return Promise.reject(new Error('服务器返回数据异常!'));
    }
    return response.data;
  },
  (error) => {
    if (error.response && error.response.data) {
      const { msg } = error.response.data;
      if (!msg || typeof msg === 'object') {
        error.response.msg = '出现未知错误，请稍后再试';
      } else {
        error.response.msg = msg;
      }
      return error.response;
    } else {
      message.error('出现未知错误，请稍后再试');
      return Promise.reject(new Error(error));
    }
  }
);
export default api;
